import { ReactNode } from "react";
import Button from "../../button/Button";
import "./EmptyTablePlaceholder.scss";

interface IProps {
    headerName: string;
    headerDescription?: string;
    hideDescription?: boolean;
    buttonName?: string;
    onClick?: any;
    imgPath?: string;
    hideButton?: boolean;
    children?: ReactNode;
}

function EmptyPlaceHolder(props: IProps) {
    return (
        <div className="emptyTablePlaceholder">
            <div className="emptyTableImageDiv">{props.imgPath && <img src={props.imgPath} alt="no-user" />}</div>

            <div className="emptyTableInfoDiv">
                <div className="emptyTableHeader">{props.headerName}</div>
                {!props.hideDescription && <div className="emptyTableDes">{props.headerDescription}</div>}
            </div>
            {!props.hideButton && (
                <Button onClick={props.onClick} variant={"secondary"} id="create-center-button">
                    {props.buttonName}
                </Button>
            )}
            {props.children}
        </div>
    );
}

export default EmptyPlaceHolder;
